import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { SearchParams, SearchResponse } from "@/api/types";

function cleanParams(params: SearchParams): Record<string, string | number> {
  const clean: Record<string, string | number> = {};
  for (const [key, value] of Object.entries(params) as [
    string,
    string | number | undefined | null,
  ][]) {
    if (value === undefined || value === null) continue;
    if (value === "" && key !== "when_date" && key !== "when_time" && key !== "bounds") continue;
    clean[key] = value;
  }
  return clean;
}

export function searchVenuesOptions(params: SearchParams) {
  return queryOptions({
    queryKey: ["search", "venues", params],
    queryFn: ({ signal }) =>
      api.get("search", { searchParams: cleanParams(params), signal }).json<SearchResponse>(),
    staleTime: 30_000,
  });
}

export function useSearchVenues(params: SearchParams, enabled = true) {
  return useQuery({ ...searchVenuesOptions(params), enabled });
}
